
import axios from 'axios';

import CacheInterceptor from './cache-interceptor';
import AuthInterceptor from './auth-interceptor';

function useInterceptors (handler) {
  axios.interceptors.request.use(handler.requestHandler);
  axios.interceptors.response.use(handler.responseHandler, handler.errorHandler);
}

const AxiosConfig = {
  install () {
    axios.defaults.withCredentials = true;

    useInterceptors(CacheInterceptor);// must be first
    useInterceptors(AuthInterceptor);
  }
};

export default AxiosConfig;
